/* eslint-disable camelcase */
import axios, { AxiosResponse } from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import { getIsDemoExperience } from 'services/globalConfig.services';

interface SubParcelParams {
  shipment_uuid: string;
  organization_id: number;
}

interface SubParcelDTO {
  pk: number;
  tracking_number: string;
  carrier_id: number;
}

interface SubParcelResponse {
  sub_parcels: SubParcelDTO[];
}

/**
 * Fetches sub-parcel
 *
 * @param params - Contains shipment_uuid and organization_id
 * @returns SubParcelResponse with sub-parcel tracking information
 */
export const fetchSubParcel = async (
  params: SubParcelParams,
): Promise<SubParcelResponse> => {
  if (getIsDemoExperience()) {
    // No UI decision to make: the service already falls back to the parent
    // tracking number, which is the correct demo display. Blocked so the
    // request does not leave the page, not because anything would break.
    return { sub_parcels: [] };
  }

  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/sub-parcel/${params.organization_id}`;

    const { data } = await axios.get(url, {
      params: {
        shipment_uuid: params.shipment_uuid,
      },
    });

    return data?.data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response.data?.message, error);
    }
    throw error;
  }
};
